module.exports = __webpack_public_path__ + "static/media/FBG2.1d119798.png";